<template>
  <span>
    <v-label>
      <v-chip v-if="item.runningStartTime">
        <RunningTimer :startTime="item.runningStartTime" />
      </v-chip>
      <template v-else>
        <v-chip small :color="item.isCompleted ? 'success' : ''">
          {{ (item.totalWorkedSeconds || 0) | formatTime }}
        </v-chip>

        <v-chip
          x-small
          v-if="item.clockedInCount > 0"
          color="info"
          class="mt-2 blink mb-2"
          style="display: block; width: fit-content;"
          >
            <v-icon small>person</v-icon> {{ item.clockedInCount }} clocked in
        </v-chip>
      </template>
    </v-label>
  </span>
</template>

<script>
import RunningTimer from "./__RunningTimer";
import formatterMixin from "@/mixins/formatterMixin";

export default {
  mixins: [formatterMixin],
  components: {
    RunningTimer,
  },
  props: {
    item: Object,
  },
};
</script>